import styled from 'styled-components'

export const RmaDetailLRButtonContainer = styled.div`
  text-align: center;
  font-family: 'Roboto';
  padding: 10px;

  > p:first-child {
    color: rgb(51, 51, 51);
    font-size: 14px;
    font-family: 'Roboto';
    font-weight: normal;
    letter-spacing: 0px;
    line-height: 20px;
    max-width: 800px;
    margin: 0px auto 10px;
  }

  > p:nth-child(2) {
    color: rgb(51, 51, 51);
    font-size: 14px;
    font-family: 'Roboto';
    font-weight: bold;
    font-style: italic;
    letter-spacing: 0px;
    line-height: 20px;
    margin: 0px auto 10px;
    max-width: 652px;
  }

  > button:nth-child(3) {
    display: block;
    width: 328px;
    height: 40px;
    border: 2px solid #2e4787;
    background: #2e4787;
    border-radius: 32px;
    margin: 40px auto 15px;
    color: #ffffff;
    font-size: 16px;
    font-family: 'Roboto';
    font-weight: bold;
    text-align: center;
    letter-spacing: 0px;
    line-height: 16px;
    cursor: pointer;


    &:hover {
      background-color: #3557b1;
      border: 2px solid #3557b1;
    }
  }

  > button:nth-child(4) {
    width: 265px;
    height: 56px;
    color: #ff4040;
    font-size: 16px;
    font-family: 'Roboto';
    font-weight: normal;
    text-align: center;
    letter-spacing: 0px;
    line-height: 28px;
    border: none;
    background: transparent;
    cursor: pointer;
  }

  @media only screen and (max-width: 680px) {
    p {
      text-align: left;
      max-width: 100%;
      width: 100%;
      margin: unset;
    }
    button:nth-child(3), button:nth-child(4) {
      width: 100%;
    }
  }
`

export const RmaDetailLRPrintSlip = styled.button`
  display: block;
  width: 328px;
  height: 40px;
  border: 2px solid #2e4787;
  background: #2e4787;
  border-radius: 32px;
  margin: 15px auto 15px;
  color: #ffffff;
  font-size: 16px;
  font-family: 'Roboto';
  font-weight: bold;
  text-align: center;
  letter-spacing: 0px;
  line-height: 16px;
  cursor: pointer;
  
  &:hover {
    background-color: #3557b1;
    border: 2px solid #3557b1;
  }
}
`
